import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../../ChallengeAdmin'
import YumField from '../../../../../components/YumInput/YumInput'
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage'
import { ReactComponent as UnitInactiveIcon } from '../../../../../assets/v3/icons/unit-inactive.svg'
import { getFieldName, getErrorMessage } from '../goalFormHelpers'

interface CustomUnitInputProps {
  control: Control<FormData>
  fieldPrefix: string
  validationRules: {
    required?: boolean
  }
}

/**
 * Custom unit text input field for custom activity types.
 * Allows users to enter a custom unit name.
 */
export default function CustomUnitInput({ control, fieldPrefix, validationRules }: CustomUnitInputProps) {
  return (
    <Controller
      name={getFieldName('customUnit', fieldPrefix) as any}
      rules={validationRules}
      control={control}
      render={({ field: { ref, ...otherField }, fieldState: { error } }) => (
        <>
          <YumField
            label={t`Enter unit for activity`}
            type="text"
            error={!!error}
            inputProps={{
              autoCapitalize: 'none',
              autoComplete: 'off',
              'aria-required': 'true',
            }}
            // InputProps={{
            //   style: {
            //     background: 'white',
            //   },
            // }}
            style={{ marginBottom: 0 }}
            //startIcon={UnitInactiveIcon}
            {...otherField}
            value={otherField.value ?? ''}
          />
          {error && getErrorMessage(error) && <ErrorMessage>{getErrorMessage(error)}</ErrorMessage>}
        </>
      )}
    />
  )
}
